var _style, _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _path6, _path7, _path8, _g5, _g6, _path9, _path10, _path11, _path12, _g7, _path13, _path14, _path15, _path16, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9628533-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ebebeb } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #ffc727 } \n\t\t.s3 { fill: none;stroke: #000000;stroke-miterlimit:10;stroke-width: 6 } \n\t\t.s4 { fill: #263238 } \n\t\t.s5 { fill: #ad6359 } \n\t\t.s6 { fill: #455a64 } \n\t\t.s7 { opacity: .1;fill: #000000 } \n\t\t.s8 { fill: #37474f } \n\t\t.s9 { fill: #ff9abb } \n\t\t.s10 { fill: #dbdbdb } \n\t\t.s11 { fill: #a6a6a6 } \n\t\t.s12 { fill: #eb9481 } \n\t\t.s13 { fill: #c7c7c7 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m114.5 598.1c2 1.2 4.6 1.2 6.6-0.1q0.8-0.5 1.7-0.9 0.9-0.5 1.7-0.9c2.2-1 3.6-3.1 3.7-5.5l0.3-8.1 26.4 0.8-0.3 8.1c-0.1 2.4 1.2 4.6 3.3 5.7q1.8 1 3.4 2.1c1.9 1.4 4.4 1.6 6.5 0.4l7.2-3.8 12.5 23.3-7.2 3.8c-2.1 1.1-3.3 3.3-3.3 5.7q0.1 2-0.1 3.9c-0.2 2.4 0.9 4.7 2.9 6l6.9 4.2-13.9 22.5-6.9-4.3c-2-1.3-4.6-1.2-6.6 0q-0.8 0.5-1.7 1-0.8 0.5-1.7 0.9c-2.2 1-3.6 3.1-3.7 5.4l-0.2 8.2-26.5-0.9 0.3-8c0.1-2.4-1.2-4.6-3.3-5.7q-1.7-1-3.4-2.1c-1.9-1.4-4.4-1.6-6.5-0.4l-7.2 3.8-12.4-23.3 7.1-3.8c2.1-1.2 3.3-3.4 3.3-5.7q-0.1-2 0.1-4c0.2-2.4-0.9-4.6-2.9-5.9l-6.9-4.3 13.9-22.4zm6.6 41.7c5.7 10.5 18.8 14.5 29.4 8.8 10.5-5.6 14.4-18.7 8.8-29.3-5.7-10.5-18.8-14.4-29.3-8.8-10.5 5.7-14.5 18.8-8.9 29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m852.7 484.3c1.3-0.8 2-2.2 1.9-3.7q0-0.6 0-1.2 0-0.6 0-1.2c0.1-1.5-0.6-2.9-1.9-3.7l-4.4-2.5 8.2-14.3 4.4 2.5c1.3 0.7 2.9 0.7 4.2-0.2q1-0.6 2.1-1.2c1.3-0.7 2.2-2 2.2-3.5v-5.1h16.5v5.1c0 1.5 0.9 2.8 2.2 3.5q1.1 0.6 2.1 1.2c1.3 0.9 2.9 0.9 4.2 0.2l4.4-2.5 8.2 14.3-4.4 2.5c-1.3 0.8-2 2.2-1.9 3.7q0 0.6 0 1.2 0 0.6 0 1.2c-0.1 1.5 0.6 2.9 1.9 3.7l4.4 2.5-8.2 14.3-4.4-2.5c-1.3-0.7-2.9-0.7-4.1 0.1q-1.1 0.7-2.2 1.3c-1.3 0.7-2.2 2-2.2 3.5v5.1h-16.5v-5.1c0-1.5-0.9-2.8-2.2-3.5q-1.1-0.6-2.1-1.3c-1.3-0.8-2.9-0.8-4.2-0.1l-4.4 2.5-8.2-14.3zm25 8.7c7.4 0 13.5-6.1 13.5-13.6 0-7.5-6.1-13.5-13.5-13.5-7.5 0-13.6 6-13.6 13.5 0 7.5 6.1 13.6 13.6 13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m295.2 149.6c1.3-0.7 2-2.1 2-3.6q-0.1-0.6-0.1-1.2 0-0.7 0.1-1.3c0-1.4-0.7-2.9-1.9-3.6l-4.4-2.5 8.2-14.4 4.4 2.6c1.3 0.7 2.9 0.6 4.1-0.2q1.1-0.7 2.2-1.2c1.3-0.7 2.2-2 2.2-3.5v-5.1h16.5v5.1c0 1.5 0.9 2.8 2.2 3.5q1.1 0.5 2.1 1.2c1.3 0.8 2.9 0.9 4.1 0.2l4.4-2.6 8.3 14.4-4.4 2.5c-1.3 0.8-2 2.2-1.9 3.6q0 0.7 0 1.3 0 0.6 0 1.2c-0.1 1.5 0.6 2.9 1.9 3.6l4.4 2.6-8.3 14.3-4.3-2.5c-1.3-0.8-2.9-0.7-4.2 0.1q-1 0.7-2.1 1.3c-1.3 0.6-2.2 2-2.2 3.4v5.1h-16.5v-5.1c0-1.4-0.9-2.8-2.2-3.4q-1.1-0.6-2.2-1.3c-1.2-0.8-2.8-0.9-4.1-0.1l-4.4 2.5-8.2-14.3zm24.9 8.7c7.5 0 13.6-6.1 13.6-13.6 0-7.5-6.1-13.6-13.6-13.6-7.5 0-13.5 6.1-13.5 13.6 0 7.5 6 13.6 13.5 13.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m707.8 598.5c0-44.8 36.4-81.2 81.2-81.2 44.9 0 81.2 36.4 81.2 81.2 0 44.9-36.3 81.2-81.2 81.2-44.8 0-81.2-36.3-81.2-81.2zm43.3 0c0 21 17 38 37.9 38 21 0 37.9-17 37.9-38 0-20.9-16.9-37.9-37.9-37.9-20.9 0-37.9 17-37.9 37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m773.4 676.4h31.2l-1.7 22.1h-27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m832.8 665.8l22.1-22 14.4 16.8-19.6 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m867.4 616.4v-31.3l22.1 1.8v27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m856.9 556.9l-22.1-22.1 16.9-14.4 19.6 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m807.4 522.3h-31.2l1.7-22.1h27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m748 532.9l-22.1 22-14.4-16.8 19.6-19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m713.4 582.3v31.3l-22.1-1.8v-27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m723.9 641.8l22.1 22.1-16.8 14.4-19.7-19.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m379.2 178.8h215.4v-123.6h-215.4q0 0 0 0v123.6q0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m631.1 178.8h-36.5v-38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m572.1 78.9h-170.4v-2.3h170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m499.8 91.6h-98.1v-2.3h98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m543.4 117h-141.7v-2.4h141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m572.1 129.6h-170.4v-2.3h170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m572.1 142.3h-170.4v-2.3h170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m475.6 155h-73.9v-2.3h73.9z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m849.8 429c1.3-0.2 2.4-1 3.1-2 0.7-1 1-2.5 0.7-3.6-0.7-2.5-3.2-4.2-5.9-3.6-1.2 0.2-2.4 1-3 2.1-0.7 0.9-1 2.4-0.7 3.5 0.7 2.5 3.2 4.2 5.8 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m561.9 329.3c2-0.5 3.5-2.5 2.9-4.5-0.5-1.9-2.4-3.2-4.5-2.8-2 0.5-3.4 2.5-2.9 4.4 0.5 2 2.5 3.3 4.5 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m616.3 152.7c1.9-0.4 3.4-2.4 2.9-4.3-0.6-2-2.5-3.3-4.5-2.8-1.9 0.4-3.4 2.4-2.9 4.3 0.6 1.9 2.5 3.2 4.5 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m730.1 77c1.1-0.2 2.1-0.9 2.7-1.8 0.6-0.9 0.8-2.1 0.6-3.1-0.6-2.1-2.8-3.6-5.1-3.1-1 0.2-2.1 0.9-2.6 1.8-0.6 0.8-0.9 2.1-0.6 3.1 0.6 2.1 2.7 3.6 5 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m649.8 426.8q0.1 0.1 0.2 0.1c3 0.4 5.2-2.7 4.6-5.3-0.5-2.6-4-4.5-6.4-2.9q-0.1 0.1-0.2 0.1c-1.6 1-2.8 2.8-2.3 4.7 0.6 1.9 2.1 3.1 4.1 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m562.1 336.8c0.1-1.4 2.2-2.4 3.1-1.1 4.2 5.3 6.4 12.2 9.4 18.2q1.4 2.9 2.8 5.7c1.7 1.9 3 4.5 5.9 4.4 3.3 0 3.6-3.9 3.6-6.6q-2.2-4.4-4.2-8.8c-6.4-14.4-11.4-29.4-14.2-44.9-1.4-7.4-2.3-15-2.7-22.6-0.4-7.5-1.3-16.4 0.7-23.8 0.7-2.2 4.1-2.1 4.6 0.1 1.7 6.8 1.4 14.3 2.3 21.3q1.2 8.5 2.9 16.9c1.3 2.1 2 5.2 5.2 4.9 2.7-0.3 3.9-3 4.4-5.6-9.9-57.7 7.5-119.6 58.8-157.2 0.7-1 1.4-2 1.8-3.1 1.2-3-1-4.9-4.1-4.4-2.1 0.3-4.1 2-6.1 2.9q0 0.1 0 0.1c-3.4 3.1-6.5 7-10.6 9.1-1.8 0.9-4.4-0.6-4.1-2.7 1.4-9.4 12.6-16.9 20.1-21.9q2.2-1.4 4.4-2.7c1-2 2.6-3.8 1.3-6.1-1-1.7-2.3-2.2-3.8-2.2-2 1.1-3.9 2-6.5 2-1.9 0-3.5-2.2-2.8-3.9 2.5-6.2 11.4-9.5 17.2-12.1 7.6-3.4 15.3-6.4 23-9.4 7.9-3 15.8-5.8 24-7.9 6-1.5 16.2-5.5 21.4-0.9 0.7 0.7 0.7 1.9 0.2 2.6-1.1 1.9-2.8 2.8-4.8 3.4-1.4 0.7-2.7 1.6-2.8 3.2-0.2 3.3 3 4.7 5.9 5 4-0.7 8.1-1.2 12-1.7 12.3-1.6 24.8-2.4 37.2-1.7 21.1 1.1 47.6 5.2 62.6 20.6 1.5 1.5-0.2 3.8-2.1 3.2-5.6-1.6-11-3.6-16.5-5.6-1.1 0-2.1 0.1-2.9 0.7-1.5 1-1.9 2.7-1.7 4.5 0.2 2.4 2.2 3.7 4.4 4.9 39.6 15 69.3 45.2 86.9 81.4 0.9 0.3 1.8 0.5 2.9 0 2.1-0.8 2.9-2.7 3.1-4.7-0.9-1.9-1.7-3.8-2.3-5.9-1.1-3.4 3.6-4.9 5.9-2.9 6.2 5.4 10 14.1 13.3 21.4 3.3 7.3 5.9 14.8 7.9 22.4 2.1 7.8 3.5 15.8 4.2 23.8 0.7 7.6 1.9 17.3-0.9 24.5-1.3 3.3-6.2 3.2-7-0.3-1.8-6.8-0.9-14.4-1.4-21.5-0.1-0.4-0.2-0.9-0.4-1.3q-0.2-0.3-0.4-0.6c-1.6-0.8-3.3-1.2-5-0.8-1.4 0.3-2.1 1.3-2.8 2.2 3 21.8 2.1 44-3 65.1-0.4 3.5-1.7 7-1.8 10.5 0.1 0.6 0.1 1.2 0.2 1.9 0.3 1.3 0.7 2.9 2.2 3.3 1.5 0.5 3.1-0.5 4.4-1.8q0.2-0.1 0.3-0.3c0.6-0.7 1-1.3 1.5-2q0.3-0.9 0.6-1.8c1.7-4.8 2.4-10.6 5.4-14.8 1-1.3 3.2-1.4 4 0.2 2.5 4.8 1.1 10.7-0.1 15.7-1.3 5.5-3 11-5 16.3-3.2 8.6-11.8 24.1-11.9 28.4-0.1 1.9 0.1 2.9 1.8 3.9 2 1.1 3.1 0.1 4.4-1.4 0.5-0.5 5-8 7.9-10.2 1.7-1.2 3.8-0.4 4 1.7 0.4 4.5-2.2 9.1-4.3 13.1-2.3 4.4-5 8.6-7.8 12.7-4.9 6.9-11.7 16.4-20.2 19.3-1.5 0.5-3-1.1-2.5-2.5 1.4-4.1 4.9-7.7 7.5-11.2q1.1-1.3 2.1-2.7c0.3-0.5 0.6-1 1-1.5q0.3-0.5 0.6-1c0.8-2.6 1.8-6.1-0.9-7-2.3-0.8-4.2 1.1-6.1 2.6q-4.1 5.4-8.7 10.3c-3.7 3.9-7.5 7.6-11.8 10.8-4 2.9-8.7 6.8-13.7 7.6-2.5 0.4-4.4-2.1-3.1-4.3 2.4-3.9 7-6.9 10.4-10 3.7-3.5 7.4-6.9 10.9-10.6 6.8-7.3 12.8-15.4 17.9-23.9q3.2-5.4 5.9-10.9 0.2-0.8 0.5-1.4c-0.1-3.1-0.4-6.1-4.5-5.3-3.3 0.7-5.3 3.5-6.9 6.3-20.3 35.5-56 63.8-109.4 75.3-11.4 2.4-22.4 3.8-33 4.3-1.5 0.4-2.8 1.1-3.8 2.2-1.2 1.4-1.6 3.6-0.3 5.1 1.2 1.3 3.8 1.2 5.5 1.5q0.2 0 0.3 0c3.8-0.4 7.7-0.8 11.3 0.3 1.6 0.5 2.4 2.7 1 4-4.2 3.4-10 3.8-15.2 4.3-6.2 0.5-12.5 0.5-18.6 0-6-0.5-12-1.3-17.8-2.8-5-1.2-11.8-2.6-15.2-6.6-1.1-1.3-0.9-3.8 1.2-4.1 5.2-0.8 10.5 1.6 15.5 2.7q3.6 0.7 7.2 1.3c2.8-0.4 6.2-0.1 7.1-3.3 0.8-2.9-2-4.2-4.5-5.3-36-3.8-66.2-19-89.5-40.8-3.6-1.9-7.6-5.4-10.3-1.5-1.8 2.6-0.4 6 1.4 9 3.6 3.4 7.8 6.7 11.4 9.3 4 2.8 0.5 7.7-3.3 6.2-13-5.4-26.3-21.5-30.9-27.7q-4-5.5-7.8-11.3c-2.8-1.3-6.4 0-7.3 3.3-0.6 2.1 0.3 4.1 1.3 6.1q1.2 2 2.4 3.9c3.4 5.2 8.7 11.2 9.8 17.3 0.3 1.6-1.3 3.6-3.1 2.8-6-2.8-10.2-9.3-13.8-14.4-4.5-6.3-8.4-12.9-12.1-19.6-3.5-6.6-6.7-13.3-9.1-20.3-2.3-6.5-5.3-13.9-4.9-20.8zm342.1-128.4c3.8 9.6 6.8 19.5 8.9 29.7 1.5 0.7 3 1.8 4.9 1.4 2.5-0.5 3.1-2.8 3.5-4.8q-0.8-3.7-1.7-7.4c-2-7.4-4.6-14.6-7.7-21.7q-0.2-0.3-0.3-0.7c-2.8-0.6-6.3 0.5-7.4 3.2q-0.1 0.1-0.2 0.3zm-158.7-104.6c11.3-0.6 22.1-0.1 32.5 1.4 3.2 0 6.7 1.3 9.1-1 1.5-1.4 1.8-3.9 0.8-5.7-0.6-1.1-1.6-1.7-2.6-2.3q-9-1.6-18.1-2c-8.1-0.4-16.2-0.2-24.3 0.4-0.8 0.4-1.6 0.8-2.3 1.3q-0.6 0.5-1.1 1.1c-1.2 3.3 2.2 5.9 6 6.8zm-91.2 4.9c1.2 0.5 2.3 0.4 3.5 0.1q0-0.1 0.1-0.1c4.8-2.2 10.5-5.7 16-5.2 2.1 0.2 3.7 2.7 2.3 4.5-1.9 2.4-4.7 4-7.6 5.4q0 0-0.1 0.1c-3.2 2-7.4 2.5-8.5 6.7-1.1 4.1 2.4 4.7 5.7 4.5 13.9-7.1 29.7-12.8 47.4-16.6q1.6-0.4 3.2-0.7c1.5-0.7 2.8-1.7 3.6-3.1 1.4-2.2-0.4-3.9-2.6-4.5-1.3-0.4-2.6-0.3-3.9-0.4-5.2 1.3-10.4 2.7-15.7 3.9-3.3 0.7-6.3-4-3.3-6.1q2.4-1.6 4.9-2.8c1-1.1 2.4-2.4 2.8-3.6 0.9-2.8-0.9-4.8-3.8-5.1-3-0.2-5.9 1.2-8.8 1.6q-6.3 2.1-12.5 4.5c-5.4 2.1-10.8 4.2-16.2 6.5-0.7 0.4-1.5 0.7-2.4 1.1-1.7 0.9-3.3 2-4.7 3.3-2 1.9-2.2 4.6 0.6 6zm-72.5 208.9c2.4 8.1 5.2 16.2 8.5 24 5.7 13.3 12.8 26.1 21.1 38 2.2 0.2 3.3 1.3 5.5-0.3 2.3-1.7 2.2-4.5 1.7-7.1-12.8-17.3-22.3-37-28.2-57.8-2.6-2.5-5.9-3.9-7.9 0.3-0.5 0.9-0.7 1.9-0.7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m846.6 122.5c3.1 2.2 8.1 7.1 12.4 5.9 1-0.2 1.5-0.9 1.6-1.8 0.8-4.4-5-8-8.1-10.2-2.3-1.6-9.4-6.3-12-3-2.6 3.3 3.9 7.5 6.1 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m867.5 136.1c1.7-0.4 3.1-2.2 2.6-4-0.5-1.7-2.2-2.9-4.1-2.5-1.8 0.4-3.1 2.2-2.6 4 0.5 1.7 2.2 2.9 4.1 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m930.2 290.5c1.2-0.3 2.3-1 3-2 0.6-1 0.9-2.4 0.6-3.5-0.7-2.4-3.1-4-5.6-3.5-1.2 0.3-2.4 1-3 2-0.6 1-1 2.4-0.6 3.5 0.6 2.4 3 4 5.6 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m933.9 352.7c1.8 1.1 4.3 0.6 5.4-1.2 1.7-2.6 3.1-5.7 3.9-8.7 0.5-2.2 1-7.9-3.1-7-2.6 0.6-3.4 3.3-4.4 5.4-0.9 2.1-2 4.2-3 6.3-0.9 1.8-0.7 4 1.2 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m567.1 242.8c1.3 2.4 4.9 2 5.9-0.5 1.6-4.3 1.5-9.6 2.4-14.1 0.7-3.5 1.9-8.1-0.8-11-0.6-0.6-1.5-0.7-2.2-0.4-3.8 2.1-4.6 8-5.5 11.8-1 4.5-2.2 9.9 0.2 14.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m912.9 242.7c14.2 89.8-47.1 174.2-136.9 188.5-89.8 14.2-174.2-47.1-188.5-136.9-14.2-89.9 47.1-174.2 136.9-188.5 89.8-14.2 174.2 47 188.5 136.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m889.5 226.4c4 13.3 6.2 27.4 6.2 42.1 0 32.7-10.8 63-29.1 87.3-26.5 35.3-68.8 58.2-116.4 58.2-54.7 0-102.4-30.3-127.3-75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m714.7 127.4c11.3-2.9 23.2-4.4 35.5-4.4 52.5 0 98.5 27.8 124.1 69.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m613.8 319c-5.9-15.7-9.1-32.7-9.1-50.5 0-52.6 28-98.8 69.8-124.3"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m756.4 99.8c3.8 0.4 20.7-2 32.3 13 11.1 14.3 16 58.3 18.5 67.8 2.6 9.6 15.2 10.7 18.5 21.8 2.8 9.5-4.1 13.2-4.6 20.3-0.4 5.5 5.3 13.5 0.6 21.7-4.4 7.5-12.4 6.2-17.1 8.6-4.8 2.4-7.5 13.7-16.3 16.9-8.8 3.3-16.9-4.7-21.7-4.5-4.7 0.2-9.9 14.9-25.4 14-15.4-0.8-20.3-13.8-26.7-16.2-6.4-2.4-22.3 2.5-29.8-5.3-7.6-7.7-9.1-18.3-12.5-22.1-3.4-3.9-10.3-3-14.6-12-4.3-8.9 3.9-14.9 4.9-22.8 0.7-5.5-4.3-10.4-1.1-18.8 4.4-11.7 18.5-9.6 23.5-21.5 4-9.4 11.6-49.9 35.6-60.5 16.6-7.3 35.9-0.4 35.9-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m806.7 178.3c0.8 2.1 2.6 3.6 4.3 5.1l5.1 4.2c3.4 2.7 6.9 5.6 9.2 9.1 2.3 3.5 3.1 7.9 1.8 11.7-0.7 1.9-1.8 3.7-3.1 5.5-1.3 1.7-2.8 3.5-3.7 5.9-0.8 2.7 0.2 5.2 0.9 7.3 0.7 2.1 1.6 4.1 2.3 6.1 1.3 4.1 1.7 8.4-0.1 12.1-0.9 1.9-2.3 3.4-4.1 4.3-1.9 0.9-4 1.3-6.1 1.5-2.2 0.2-4.4 0.2-6.6 0.3-2.2 0.1-4.6 0.3-6.4 1.6 1.9-1.1 4.2-1 6.4-0.9 2.2 0.1 4.4 0.3 6.6 0.2 2.3 0 4.6-0.3 6.8-1.2 2.1-1 4-2.8 5.1-4.9 2.5-4.2 1.9-9.4 0.6-13.6-0.7-2.2-1.5-4.3-2.2-6.3-0.8-2.1-1.3-4.1-0.7-5.7 1.2-3.6 5.1-6.8 6.5-11.5 1.4-4.5 0.5-9.8-2.4-13.5-2.8-3.7-6.4-6.4-10-9l-5.5-3.7c-1.7-1.4-3.6-2.6-4.7-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m698.7 123.5c-4.1 6.9-6.5 14.6-9.6 21.8-1.6 3.6-3 7.3-4.8 10.7-0.9 1.7-1.8 3.4-3 4.8q-0.4 0.5-0.9 0.9c-0.3 0.2-0.6 0.5-1.1 0.7q-1.2 0.7-2.5 1.3c-3.5 1.7-7.3 3.2-10.8 5.3-3.4 2.1-6.7 5-8.4 9-0.8 1.9-1.3 4.1-1.1 6.2 0.2 2.1 1.1 4.1 2 5.8 1.9 3.5 3.8 7 4 11 0.4-4-1.3-7.9-2.9-11.5-0.8-1.8-1.4-3.6-1.5-5.4-0.1-1.9 0.4-3.7 1.3-5.3 1.7-3.3 4.5-5.9 7.8-7.8 3.3-2 7-3.4 10.7-5 0.9-0.5 1.8-0.9 2.7-1.5 0.8-0.4 2-1.3 2.5-2.2 1.4-1.6 2.3-3.4 3.3-5.2 1.7-3.7 3.2-7.4 4.5-11.1l3.8-11.3c1.2-3.8 2.3-7.5 4-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m668.3 233.2c1.8 2.2 2.1 5.2 2.8 7.9 0.7 2.7 1.4 5.5 2.2 8.2 0.8 2.8 1.8 5.5 3.2 8.1 1.4 2.6 3.2 5.1 5.8 6.9 5.5 3.3 11.9 2.7 17.4 1.5 2.8-0.6 5.5-1.3 8.3-1.8 2.7-0.6 5.5-1 8.3-0.2-2.6-1.3-5.7-1.3-8.5-1.1-2.9 0.3-5.6 0.9-8.4 1.2-5.5 0.7-11.3 1-15.7-1.8-2.2-1.3-3.8-3.5-5.1-5.8-1.4-2.4-2.5-5-3.5-7.6-1-2.6-1.9-5.3-2.8-8q-0.7-2-1.6-4c-0.6-1.2-1.1-2.7-2.4-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m696.7 256.9c-45.3 51.3-100.1 157-87.6 177.1 13.8 22.5 76.9-49.5 76.4-53.4-0.4-3 19.7-66.5 35-112.7 15.4-46.2-12.6-23.7-23.8-11z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m685.9 380.6c1.7-6.7 29.2-90.5 36.9-117 7.7-26.4-1.2-34-26-8.8-24.9 25.2-77.7 107.8-88.5 150.6-10.3 41.3 10.6 40.1 37.1 19.9 21.7-16.6 40.5-44.7 40.5-44.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m656 309.6l0.5 106.1c16.7-16 29.4-35.1 29.4-35.1 1.7-6.7 29.2-90.5 36.9-117 7.7-26.4-1.2-34-26-8.8-10.4 10.6-25.8 31.2-40.8 54.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m851.5 430.6l-188.5 1.8 9.2-64.3c0 0-8.2-15.7-8.2-29.8 0-20.1 49.5-95.1 53.2-98.5 15.1-13.4 42.5-14.4 50.6-1.3 36.7 60 48.4 97.1 57.8 139.1 0 0 16.2 20.8 25.9 53z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m730.8 359c-9.2 0-18.5 0.2-27.7 1.8-4.6 0.7-9.1 1.7-13.6 2.8-2.3 0.6-4.6 1-6.8 1.5-2.4 0.4-4.9 0.8-7.2 0.6-0.2 0-0.3 0.4 0 0.4 2.2 0.4 4.4 0.7 6.7 0.7 2.2 0 4.4-0.2 6.6-0.6 4.6-0.7 9.2-1.7 13.9-2.4 9.3-1.6 18.7-3.1 28.1-3.9 0.4 0 0.4-0.9 0-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m752.1 371.3c-7.4-1.9-14.9-3.3-22.4-4.2-3.8-0.4-7.6-0.6-11.4-0.6q-2.7-0.1-5.5 0c-2 0-4 0.4-6 0.4-0.2 0-0.3 0.4-0.1 0.4 1.9 0 3.8 0.5 5.7 0.7q2.8 0.2 5.6 0.5c3.8 0.4 7.6 0.8 11.4 1.1 7.5 0.7 15.1 1.4 22.6 2.4 0.4 0 0.5-0.7 0.1-0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m724.2 283.7c0 0 36.2-30.4 57.9-27.9l14.3 20.4c0 0 0.5 14.4 2.6 10.7 5.4-9.1 16.5-46.7-2.1-63.1-17.1-15.1-54.6-15.1-79.8-10.5-24.3 4.4-38.5 17.4-32.4 33.5 6.1 16.1 39.5 36.9 39.5 36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m722.4 276.2c0 0-25.8-21.6-27.7-33.3-2-11.8 22-21.1 37.3-24.3 23.6-4.9 39.2-2.2 51.2 11.1 12 13.4-60.8 46.5-60.8 46.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m754.3 248.3c-1.1 3.6-19.8 25.6-36.1 23.6-5.3-0.6-3.1-29.7-3.1-29.7l-0.4-2.2-4.6-30.6 37.1-20.2 5.3-2.7c0 0 0.7 8.5 1.5 19q0 0.8 0.1 1.5 0.1 0.9 0.1 1.8 0.2 2.3 0.4 4.7c0.1 1.3 0.2 2.4 0.2 3.7 0.1 1.3 0.1 2.6 0.2 3.9 0.4 12.7-0.3 25.8-0.7 27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m754 205.5c-10.4 23.4-30.2 31.8-39.3 34.5l-4.6-30.6 37.1-20.2 5.3-2.7c0 0 0.7 8.5 1.5 19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m676.1 154.3c-15.9 51.9 13.5 67.3 24.7 70.8 10.1 3.1 45.2 12.3 66.4-37.7 21.1-50.1 2-73.9-20.9-82.2-22.9-8.3-54.3-2.9-70.2 49.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m685.9 151.1c1.2 0.3 2.5 0.3 3.8 0.5 1.4 0.2 2.6 0.5 3.9-0.2 0.8-0.4 1.1-1.6 0.9-2.3-0.7-1.7-2.5-2.4-4.2-2.7-1.9-0.3-3.5-0.1-5.1 0.9-1.6 0.9-1 3.4 0.7 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m722.9 155.9c-1.1-0.7-2-1.5-3.1-2.3-1.1-0.9-2.2-1.5-2.7-2.9-0.2-0.8 0.3-1.9 1-2.2 1.8-0.8 3.5-0.1 4.9 1 1.6 1.1 2.5 2.3 3.1 4.2 0.5 1.7-1.7 3.1-3.2 2.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m712 167.5c0.1-0.2 0.3 0.2 0.2 0.3-1 3.7-1.5 8 1.5 10.1 0.1 0 0.1 0.2-0.1 0.2-3.9-1.6-3.1-7.4-1.6-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m716.3 164.4c6 1 3.6 13-2 12.1-5.5-0.9-3.1-12.9 2-12.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m718.5 165.5c0.9 0.9 1.7 2.3 2.9 2.7 1.4 0.4 2.8-0.6 4-1.6 0.1-0.1 0.2 0 0.2 0.2-0.5 2.3-1.8 4.5-4.4 4.3-2.3-0.1-3.5-2.5-3.6-4.9 0-0.5 0.5-1 0.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m691.3 161.4c0-0.2-0.3 0.1-0.3 0.2-0.7 3.8-2.1 7.9-5.7 8.4-0.2 0-0.2 0.2-0.1 0.2 4.2 0.3 6.1-5.2 6.1-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m688.8 156.8c-5.8-1.7-8.9 10.1-3.4 11.7 5.3 1.6 8.3-10.2 3.4-11.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m686.2 156.9c-1.1 0.4-2.3 1.3-3.5 1.1-1.3-0.2-1.9-1.8-2.4-3.2-0.1-0.1-0.2-0.1-0.2 0.1-0.7 2.2-0.5 4.8 1.5 5.8 1.9 0.9 3.8-0.7 5-2.8 0.2-0.4 0-1.1-0.4-1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m709.5 201.3c-1 0.7-2.1 1.8-3.5 1.7-1.3-0.1-2.7-0.9-3.9-1.5-0.1-0.1-0.2 0-0.1 0.1 0.7 1.6 2.6 2.8 4.4 2.8 1.7-0.1 2.8-1.4 3.4-2.9 0.1-0.2-0.1-0.3-0.3-0.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m704.2 191.9c-2.6-1.5-7.7-2.6-11.6-3.2-0.4-0.2-1.2-0.8-1.2-1.2 0.1-0.1 2.5-7.5 2.5-7.5-1.2 0.2-7 1-6.5-0.4 4.2-11.7 8.8-24.6 15.3-35.4 0.2-0.3 0.8-0.1 0.7 0.3-3.6 11.4-9.1 22-12.8 33.4 1.8-0.2 4.8-0.5 6.2-0.1 0.4 0.2-2.5 7.4-2.7 8.7 0 0 7.2 0.2 11.1 5.3 1.2 1.4 0.8 1.2-1 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m698.4 187.5c3 0.6 8.9 4.6 9.9 9.7 0.8 4.4-6.6-1.2-8.1-1.1-1.3 0.1-4.7-9.1-1.8-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m707.2 198.9q-0.3 0-0.6-0.1c-2-0.5-5-2.5-6.2-2.7q-0.1 0-0.2 0-0.3 0-0.6-0.4c0.8-2 3.2-3.6 6.9-2.5q0.4 0.6 0.7 1.2 0.2 0.2 0.3 0.5 0.2 0.4 0.3 0.8 0.2 0.3 0.3 0.6 0.1 0.5 0.2 0.9c0.2 1.3-0.3 1.7-1.1 1.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m725.7 107.4c0 0-4.4 7.5-3.3 14.1 2.3 13.6 17.5 14.5 21.1 20.7 3.3 5.7-0.9 14.4 2 20.1 4 7.8 12.5 7.6 12.3 12-0.3 4.4-1.3 18.4 3.5 21.5 4.7 3.2 53.9-77.5-15.5-94.3 0 0-8.3-6.5-25-3.3-18.5 3.5-33.1 28.2-33.1 28.2 0 0 0.4-0.3 3.4-1.7 4.1-2 6.2-4.4 9.2-5.6 4.6-1.9 6.4-0.1 11.2-1.9 7.3-2.7 14.2-9.8 14.2-9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m727.9 103.9c-2.1 3.2-3.8 6.5-5.1 10-1.2 3.4-2.1 7.2-1.4 10.6 0.7 3.5 3.2 6.4 6.1 8.4 2.9 2.2 6.4 3.5 9.5 6 1.5 1.2 2.9 2.7 3.6 4.7 0.7 2 0.6 4 0.5 5.9-0.3 3.8-0.5 7.4 1.1 10.6 1.5 3.2 4.5 5.7 8.1 6.5 3.4 1 7.5 1.1 10.4 3.6-3.1-2.2-7-2-10.7-2.7-3.7-0.7-7.1-3.3-9-6.7-2.1-3.5-1.7-7.7-1.5-11.4 0.1-1.8 0.1-3.6-0.5-5.2-0.5-1.5-1.8-2.9-3.1-4-2.8-2.2-6.3-3.7-9.4-6-1.5-1.1-2.9-2.5-4.1-4-1.1-1.6-2.1-3.4-2.4-5.4-0.6-4 0.6-7.8 2-11.2 1.6-3.5 3.6-6.7 5.9-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m725.6 106.7c-1.6 3.1-3.6 5.9-6 8.5-2.4 2.6-5.5 4.8-9.1 5.7-1.7 0.4-3.6 0.4-5.2 0.5-1.6 0.1-3.3 0.5-4.4 1.4-1.3 1-2.6 2.4-4.2 3.2-1.6 0.8-3.3 1.3-5.1 1.3 1.7-0.4 3.3-1 4.7-2 1.4-1 2.4-2.2 3.7-3.5 1.5-1.4 3.3-1.8 5.1-2.1 1.9-0.2 3.5-0.1 5-0.5 3.2-0.8 6-2.7 8.5-5 2.5-2.3 4.8-4.9 7-7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m755.1 185.4c0 0 15.1-14.1 21.8-8.4 6.6 5.8-7.3 27.9-16.8 29.3-9.5 1.4-11-7.4-11-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m772.7 183.3c0.2 0 0.2 0.2 0 0.2-6.7 1.2-11.2 6.3-14.8 11.7 2.4-1.9 5.2-2.6 7.8 0.2 0.1 0.2-0.1 0.4-0.3 0.3-2.4-1-4.3-1-6.5 0.7-1.5 1.2-2.7 2.8-3.9 4.3-0.4 0.5-1.4 0-1-0.6q0-0.1 0-0.2c1.6-7.9 10.1-17.6 18.7-16.6z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m722.4 276.2c0 0 30.5-43.6 64.5-45.5l-4.8 25.1c0 0-20.1-1.5-57.9 27.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m791.2 256.9c-6.2-1.2-12.4-0.3-18.3 1.1-6 1.4-11.7 3.7-17.2 6.4-5.5 2.7-10.7 5.9-15.8 9.3l-7.5 5.3-7.3 5.8-0.8 0.6-0.8-0.5c-6.1-3.7-11.8-7.8-17.3-12.3-2.7-2.3-5.4-4.6-7.9-7.2-2.5-2.5-4.8-5.2-6.7-8.1 4.6 5.3 10.1 9.6 15.7 13.8 2.9 2.1 5.8 4 8.7 5.9 3 1.9 5.9 3.7 8.9 5.5l-1.6 0.1 7.3-5.9c2.5-1.9 5-3.7 7.6-5.5 2.6-1.7 5.3-3.4 8-5 2.8-1.4 5.5-3 8.4-4.2 5.7-2.7 11.8-4.6 17.9-5.7 1.6-0.3 3.2-0.5 4.7-0.7 1.6-0.1 3.2-0.2 4.7-0.1 3.2 0 6.3 0.4 9.3 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797 279.7c-3-3.6-5.4-7.4-7.8-11.4-2.3-3.9-4.6-7.9-6.3-12.2 2.9 3.6 5.4 7.5 7.7 11.4 2.4 3.9 4.6 7.9 6.4 12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m737.4 266.5c0 0 3 13 3.7 31.9 0.2 7.5-2.3 34.4-10.6 33.5-8.3-0.8 5-18.4 7.1-32.6 2.3-14.4-1.7-24.5-2.3-32.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m707 265.2c0 0-3.7 11.5-5.8 28.5-0.8 6.8-0.7 31.2 6.9 31.1 7.6-0.1-3-17-3.9-30-0.9-13.1 3.5-22 4.7-29.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m613.1 433.6c16.1 11 38.2 9.3 114.4-3.3 10.6-1.8 26.5-78.2 15.2-79.7-15.1-2.1-72.8 8.3-76.7 9.5-33.4 10.1-63.8 66-52.9 73.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m733 350.6c0 0 33.9-0.8 51.8 4.3 24.1 6.8 42 22.6 49.1 29.6 14.9 14.8 40.6 60.7 28.7 70.4-10.8 8.8-34.8-39.5-34.8-39.5 0 0 32.6 45.2 17.6 53.4-15 8.2-39.5-49.4-39.5-49.4 0 0 32.3 47.2 15.6 53.2-12.7 4.6-37.9-46.4-37.9-46.4 0 0 27.5 40.8 14.7 46-14.2 5.8-40.4-39.7-40.4-39.7-34.8 7.8-54.6-2.7-67.8-11.9-3.2-2.2 42.9-70 42.9-70z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m817.6 399.1c4 5.2 8.1 10.4 11.6 15.9 3.6 5.5 6.9 11.1 9.9 16.9 7.4 14.3 9.8 24.4 9.6 23.8-5.1-14.4-17.5-34.3-21-39.8-3.5-5.5-6.8-11.2-10.3-16.7-0.1-0.1 0.1-0.2 0.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797.5 411.5c4.8 6.8 9.9 13.4 14.4 20.5 4.5 7 8.2 14 12.2 21.3 0.3 0.6-0.1 0.6-0.4 0-4.3-7.1-8.9-13.4-13.3-20.5-4.3-7-8.5-14.3-13.1-21.2-0.1-0.1 0.1-0.2 0.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m778.3 419.1c7.9 10 14 21.5 19.6 32.9 0.3 0.6-0.2 0.5-0.5 0-6.4-11.1-11.2-19.9-19.5-32.7-0.1-0.2 0.2-0.5 0.4-0.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m730.7 346.6l-36.8 93.6c0 0-68.3 9.1-83.6-3.6-10.1-8.3 21.3-69 59-77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m672.6 435c3.4-10.4 7.4-20.6 11.4-30.8 4.1-10.2 8.1-20.4 12.4-30.5 2.4-5.7 4.8-11.4 7.4-17.1 0.1-0.1 0.3 0 0.3 0.1-3.4 10.4-7.4 20.6-11.4 30.8q-5.9 15.4-12.2 30.6-3.5 8.6-7.4 17c-0.1 0.3-0.6 0.2-0.5-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m729.6 349.2l1.9-3 0.2-0.4c-8.9 1-17.8 2.2-26.7 3.7-15.2 2.8-30.7 5.4-45.1 11.4-10 4.8-18.9 12.2-25.6 21 7.6-7.9 16.6-14.4 26.5-18.9 6.1-2.4 12.5-4 18.9-5.6 14.8-3.6 36.4-7.9 51.6-11.1l-0.2-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m793 318c0 0-4-57.2-4.8-87.3-0.8-30.2 14.3-34.5 31.7-9.9 17.3 24.6 45.7 52.3 48.9 109 8.2 146.9-75.8-11.8-75.8-11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m751 142.7l-32.2 80c-1.2 2.3-0.3 4.4 2.1 4.8l35.9 13.2c2.4 0.4 5.3-1.2 6.6-3.5l32.2-80c1.2-2.3 0.2-4.5-2.1-4.8l-36-13.3c-2.4-0.3-5.3 1.3-6.5 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m754.1 143.7l-32.2 80c-1.2 2.3-0.3 4.4 2.1 4.7l35.9 13.3c2.4 0.3 5.4-1.3 6.6-3.6l32.2-79.9c1.2-2.4 0.3-4.5-2.1-4.8l-36-13.3c-2.3-0.3-5.3 1.3-6.5 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m765.3 149.1c-0.3 2-2.2 3.3-4.2 3-2-0.3-3.4-2.2-3-4.2 0.3-2 2.2-3.3 4.2-3 2 0.3 3.3 2.2 3 4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m819 391.6c14.7 22.4 47.1 6 50.7-10.9 8.4-39.8-4.6-103.6-14.9-138.9-3.3-11.4-80.9 7.1-79.3 19.6 1.8 15.1 14.6 86.4 43.5 130.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m850.7 267.5c0 0 7.7-23.6 3.4-50-3-18.2-14-57.2-65.4-77.1-12.2-4.7-33-2.8-15.8 12.1 12.1 10.7 23 13.7 29 21.2 0 0-26.1 5.6-30.4 18-1.9 5.5-6.7 20.8-8.8 33.2 0 0 2.6 1.2 6.1 2.2 0 0-2.2 17.8 6.7 34.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m848.4 200.6c-7.5-6.2-23.5-19-40.3-24.9-18.6-6.6-56.3-14.2-61-0.4-3.4 10.1 10.7 14.3 10.7 14.3 0 0-16.2 0.1-17.3 10-1.1 8.9 10.1 11.5 10.1 11.5 0 0-9.9 1.8-9.2 10.6 0.8 10.6 21.3 5.1 31.4 15.1 2.3 2.3 75.6-36.2 75.6-36.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m804.5 196.5c-8-4.6-28.8-10.5-46.4-7.2-0.4 0.1-0.6 0.5-0.2 0.5 20.1 0.4 38.7 4.6 46.5 6.9 0.1 0.1 0.2-0.1 0.1-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797.3 215.2c-7.3-3.3-29-8.5-46.7-4.5-0.4 0.1-0.5 0.5-0.2 0.5 21.1-0.5 38.9 2.3 46.8 4.1 0.1 0.1 0.2-0.1 0.1-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m818.3 397.4c15.9 21.9 49.7 5.2 53.9-12.1 9.7-40.4-2.9-104.6-13.1-140.1l-86.9 24.5c1.7 15.2 16 86.2 46.1 127.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m776.5 268.5l-4.3 1.3 0.1-0.1c2.8 13.9 6.2 27.7 10 41.3 7.7 26.6 22.9 77.1 46.1 92.6 5.9 3.8 13.1 4.8 19.9 2.9-6.6 3.2-14.7 2.9-21.2-0.5-26.3-14.2-39.4-66.8-46.8-94.5-3.3-13.8-6.2-27.8-8.2-41.9h0.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m820.4 282c-6.4 1.9-31.7 10-37.7 12.8-0.2 0.1-0.1 0.4 0.1 0.4 6.6-1 32.2-8.4 38.6-10.4 12.8-3.9 25.7-7.6 38-12.8 0.3-0.1 0.2-0.6-0.1-0.6-13.2 2.5-26.1 6.7-38.9 10.6z"
  }))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa 4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m405 574.9c88 83.2 168.9 174.1 173 220 5.8 63.7-24.9 82.2-42.7 82.2-48.5-0.1-135.8-195.7-162.3-269.9-25.8-71.9 12.7-50.6 32-32.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m519.5 871.5c-49.7-32.7-122.7-197.6-146.5-264.3-7.9-22.1-9.8-35.4-8-42.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m134.6 932.9h334.6c4.7-5-55.8-303-75.8-359.6-12.9-36.5-72.3-45-99.6-17.2-106.4 108.4-162.1 373.3-159.2 376.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m510.6 866.5c-26.9-20.4-13.6-83.8 1.6-188.1 2.6-18.3 126-63.6 128.5-44 3.2 24.7-16.3 141.1-27.5 169.5-22.1 56-71.3 86.4-102.6 62.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m619.6 733.8c23.9-25.3 55.2-63 55.4-78.9 0.1-16.6-1.7-75.3-6.6-88.8-4.8-13.5-30.8-48.3-42.7-53-9.6-3.7-14.8 8.2-3.7 29.7 12.4 24.2 8.5 33.9 9.1 41.6 0.5 8-13 41.9-24.2 44.8-6.7 1.6-20.4 1.5-23.5-10.5-3.1-11.9 0.1-22.7-4.4-43.6-3.6-16.2-17.1-26.3-22.7-23.5-5.6 2.8-1 12.5-4.8 36.8-2.3 15.1-4.6 26-22.8 48.1-15.9 19.3-16.9 46.1-16.9 46.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m676.2 617.6c-0.6-9.2 5.7-36.8 3.6-48.9-2.1-12.1-16.1-56.6-29.6-60.3-16.9-4.6-12 31.6-8.5 47.1 3.6 15.5-6.4 43.4-6.4 43.4l23.3 10z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m631.8 605.2c4.2-14 9.5-28.3 9.7-43-0.7-10.6-2.7-21-3.2-31.7-0.1-6.3-0.5-13.2 2.8-18.9 1.1-1.9 3.1-3.3 5.2-3.5-2.1 0.5-3.8 1.9-4.8 3.8-2.6 5.7-2 12.3-1.7 18.5 0.7 8.4 2.1 16.8 3.1 25.3 2.2 17.1-4.9 33.9-11.1 49.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m675.4 625.5c1.9-8.9 15.6-33.4 17-45.5 1.3-12.2 0.3-58.6-11.5-66-14.9-9.4-20.2 26.5-21.1 42.3-0.9 15.8-18.2 39.5-18.2 39.5l19.5 16.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m636.6 600.9c7.9-12.2 16.9-24.3 21.1-38.3 2.3-10.3 3.2-20.8 5.7-31 1.7-6.1 3.2-12.8 7.9-17.3 1.6-1.5 3.9-2.2 5.9-1.8-2.1-0.2-4.1 0.7-5.5 2.2-4.2 4.7-5.4 11.2-6.8 17.2-1.6 8.2-2.7 16.5-4 24.9-2.7 16.9-14 30.9-24.3 44.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m639.7 622.3c-8.1 7-19 10.1-29.3 12.2-3.6 0.6-7.2 0.8-10.7 1.1-10.5 0.5-20.9 2.7-30.3 7.5-3.2 1.5-6.2 3.4-9.3 5.3 11-9.2 25.2-14.3 39.5-14.8 13.9-1 28.3-3.6 40.1-11.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m671.4 666c3.8-8.1 16.8-39.7 17.6-53.1 0.8-13.4-3-64.6-16.6-72.4-17.1-9.7-21 30-21.1 47.5-0.1 17.4-15.7 35.9-15.7 35.9l24.9 22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m653.7 560.6c0.3 5.8-0.1 11.7-0.4 17.4-0.2 5.5-0.1 11.2-1.2 16.5-1.1 5.4-3.4 10.3-6.2 15-1.4 2.3-2.9 4.5-4.4 6.6-1.7 2.4-3.7 4.6-5.3 7-0.2 0.2-0.6 0-0.5-0.3 3-4.4 5.4-9.3 7.7-14 2.4-4.9 4.2-10.2 5.3-15.6 2.2-10.8 2.1-21.9 4.2-32.7 0.1-0.4 0.7-0.3 0.8 0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m652.1 594.5c0.1-16.6-2-34.6 5.6-50.1 4.5-8.4 13.8-8.1 18.7-0.2 7.8 12.5 9.7 27.5 11.2 41.8-2.3-12.3-6.4-38.6-17.5-45.2-18.8-6.2-16.8 42.6-18 53.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m640 718.4l-142.8 17.9c0 0-21.6 119 20.8 135.4 42.4 16.4 77.5-19.7 95.2-67.8 17.7-48 26.8-85.5 26.8-85.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m492.3 816.1c-0.6-13.3-0.5-26.7 0-40.1 0.7-13.3 0.9-26.9 4.6-39.8 0 0 0.1-0.2 0.1-0.2h0.1l7.4-1.3-7.3 1.8 0.2-0.1c-2.9 12.9-2.9 26.4-3.7 39.7-0.3 9.9-1.1 30.1-1.4 40z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m506.3 769.4c20-3.7 74.5-11.8 110.6-12 0.2 0 0.3 0.9 0.1 0.9-29.9 5.1-90.3 10.7-110.5 12.4-0.4 0-0.5-1.3-0.2-1.3z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m250.7 796.7c2.7-11.7 46.7-157 59-202.8 11-41.1 2.3-57-29.1-29.6-57.7 50.5-168 199.9-184.9 274.1-16.2 71.4 42.1 72.6 87 36.8 36.7-29.4 68-78.5 68-78.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m245.1 815.5c13.4-55.2 29.4-109.7 48-163.4-13.3 55.2-29.4 109.8-48 163.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m284.4 683.9c2.4-7.2 6.2-13.6 10.6-19.7-1.9 7.3-5.8 13.9-10.6 19.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m117.2 886.1c23.6 22.4 74.3 17.2 203.3 16.2 17.8-0.1 50.7-126.3 31.7-127.2-24.1-1-117.5 0.2-124.3 1.1-57.5 8-126.7 94.7-110.7 109.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m332.4 780.7c0 0 47.7-16.9 75.5-18.1 37.2-1.5 70 12.5 83.4 19.2 27.9 14 85.7 67.2 73.3 86.5-11.2 17.5-67.6-39.8-67.6-39.8 0 0 67.1 48.9 49.7 67.5-17.3 18.6-79-51.7-79-51.7 0 0 67.8 51.9 46.9 68.2-15.9 12.3-75.3-48.1-75.3-48.1 0 0 58 44.9 42.3 58.3-17.4 14.8-75.8-37.6-75.8-37.6-45.7 27.3-78.7 21.6-101.6 14.7-5.6-1.6 28.2-119.1 28.2-119.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m474.9 810.1c8.1 5.4 16.3 10.9 23.9 17.1 7.6 6.1 14.9 12.6 21.9 19.4 17.1 16.8 25.2 30 24.6 29.2-13.9-17.9-40.7-40.4-48.3-46.6-7.5-6.2-14.8-12.7-22.3-18.8-0.2-0.2 0-0.5 0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m452.2 837c10 7.5 20.2 14.5 29.9 22.3 9.7 7.9 18.1 16.1 27.2 24.6 0.7 0.7 0.2 0.8-0.6 0.2-9.4-8.1-18.7-14.9-28.2-22.9-9.5-7.9-18.8-16.3-28.5-23.9-0.2-0.2 0-0.4 0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m428.5 856.7c15.9 10.5 29.8 24 43.2 37.6 0.6 0.6-0.1 0.8-0.9 0.1-14.1-12.8-25.1-22.9-42.7-37.2-0.3-0.2 0-0.8 0.4-0.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m328.3 761.4l-81.8 170.5c0 0-128.5-19.4-145.5-44.8-12.2-18.1 61.1-100.5 124.5-111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m155.4 815.1c7.5-10.3 33.6-32.7 70.2-39.5 0.3-0.1 0.5 0.4 0.2 0.5-26.8 7.7-62 30.1-70.1 39.3-0.2 0.3-0.5-0.1-0.3-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m225.2 902.3c6.5-17 14-33.7 21.6-50.4 7.5-16.6 15-33.3 23-49.8 4.5-9.3 8.9-18.7 13.7-27.8 0.2-0.3 0.6-0.1 0.5 0.2-6.6 17-14 33.7-21.4 50.4q-11.2 25.1-22.8 49.9c-4.4 9.4-9 18.7-13.8 27.8-0.2 0.5-1 0.2-0.8-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m328 759.8c-7.1-0.1-14.1 0.9-21.2 1.8q-10.6 1.3-21.2 3c-14 2.1-43.9 5-68.4 12.9-0.3 0.1 1.5 1 1.8 0.9 11.5-4.4 100.7-14.5 107.8-16.3-0.2 0.6-0.3 1.1-0.3 1.7-0.1 0.4 0.4 0.7 0.7 0.3 0.7-0.8 1.1-1.7 1.7-2.6 0.5-0.8 0.1-1.7-0.9-1.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m261 903.1c-4.4 10.2-9 20.3-13.6 30.3-10.4-1.6-20.8-3.4-31.1-5.5-29.6-6-60.1-12.5-88-24.1 9.7 2.8 19.6 5.1 29.4 7.4 19.8 4.7 68.5 14.8 89.1 19.3l-1.5 0.7c5.1-9.4 10.2-18.9 15.7-28.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m370.3 613.1c-17.1-1.1-53.9-30.9-58.3-57.1-0.3-1.8 7.6-16.9 16.3-35.7 5.2-11.4 10.8-24.2 15-36.3 0.8-2.5 69.4 44.9 69.4 44.9 0 0-16.3 22.7-23.6 43.8q-0.9 2.7-1.2 5.2c0 0.2-0.1 0.5-0.2 0.8-1.7 10 0.8 35.6-17.4 34.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m387.9 577.9c0 0.2-0.1 0.5-0.2 0.8q-3.7-0.7-7.9-2.3c-44.3-16.6-36.5-76.5-33.8-91.5 12.8 6.7 66.7 44 66.7 44 0 0-16.4 22.7-23.6 43.8-0.6 1.8-1 3.5-1.2 5.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m419.3 460.3c-1 20.6 12.7 38 30.7 39 18.1 0.9 33.5-15 34.6-35.5 1.1-20.6-12.6-38-30.7-39-18-0.9-33.5 15-34.6 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m408.7 461.1c-1.2 22.8 14.1 42.2 34.1 43.3 20.1 1 37.3-16.6 38.5-39.5 1.2-22.9-14.1-42.3-34.1-43.3-20.1-1.1-37.3 16.6-38.5 39.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m450.5 383.2c0 0 24.3 14.7 24.4 40.5 0 25.8-11.1 50.9-13.6 51.8-2.6 0.8-10.8-92.3-10.8-92.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m339.6 394c-13.6 26.4-13.3 110.1 3.4 131.7 24.2 31.3 71 42.3 99.5 11.6 27.6-29.8 25.3-138.8 6-159.2-28.5-30-88.9-23.3-108.9 15.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m411.3 459.8c0-0.2-0.4 0.3-0.4 0.5 0.1 5.6-0.6 12.1-5.7 14-0.2 0-0.1 0.3 0 0.3 6.3-0.9 7.2-9.5 6.1-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m406.3 453.9c-9.1-0.7-9.8 17.5-1.4 18.1 8.2 0.7 9-17.5 1.4-18.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m442.4 460.9c0-0.2 0.4 0.3 0.4 0.5-0.4 5.7 0.1 12.2 5.1 14.2 0.1 0.1 0.1 0.4-0.1 0.4-6.2-1.2-6.7-9.8-5.4-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m447.6 455.3c9.1-0.4 9.1 17.8 0.7 18.1-8.3 0.3-8.3-17.9-0.7-18.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m399.5 445.3c2.5-0.5 4.7-1.4 7.1-2.2 2.7-0.8 5-1.2 6.8-3.6 1-1.2 0.7-3.6-0.4-4.7-2.6-2.5-6.2-2.2-9.5-1.3-3.7 1-6.2 2.6-8.4 5.7-2.1 2.9 1.1 6.8 4.4 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m455 446.4c-2.5-0.5-4.7-1.4-7.1-2.2-2.7-0.8-5-1.2-6.9-3.6-1-1.2-0.7-3.6 0.4-4.7 2.7-2.5 6.3-2.3 9.6-1.4 3.6 1 6.2 2.7 8.3 5.7 2.1 3-1 6.9-4.3 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m402.3 512.6c1.3 1.3 2.5 3.2 4.6 3.5 1.9 0.2 4.2-0.6 6.1-1.2 0.2-0.1 0.3 0.1 0.2 0.3-1.5 2.1-4.7 3.3-7.3 2.7-2.5-0.5-3.7-2.8-4.2-5.1-0.1-0.3 0.4-0.4 0.6-0.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m409.1 494.1c3 5 7.5 7.9 12.5 9 2.2 0.6 4.5 0.8 6.8 0.6q0.7 0 1.4-0.1c0.4 0 0.7 0 1.2-0.1 0.7-0.1 1-0.6 1.2-1.2v-0.1c0-0.2 0-0.3 0-0.5q0 0 0-0.1v-0.5c0.3-4.3 0.1-10.9 0.1-10.9 1.6 0.9 9.5 4.8 9.4 2.5-0.3-18.7-0.7-39.6-5-58.3-0.1-0.6-1.1-0.5-1.1 0.2-0.3 18 2.5 36 2.4 54.2-2.5-1.1-6.7-3.1-8.9-3.1-0.7 0.1 0.5 12.7 0.2 14.7q0 0-0.1 0.2c-7.3 0.6-12.7-1.8-19.5-7-0.4-0.3-0.9 0-0.6 0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m425.5 501.1c0 0-3.8 4.8-8.8 6.4-1.8 0.6-3.8 0.8-5.8 0.2-4.2-1.3-4.2-5.2-3.3-8.4 0.7-2.7 2-5 2-5 0 0 6 5.9 15.9 6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m416.7 507.5c-1.8 0.6-3.8 0.8-5.8 0.2-4.2-1.3-4.2-5.2-3.3-8.4 4.5 0.6 8.9 3.8 9.1 8.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m331.9 473.5c9.9 2.9 20.6-26.8 23.6-38.1 2.7-10.1 5.4-41.8 5.8-43.9 0.5-2.2 43.2 27.3 67.8 19.7 24.5-7.7 40.7-30.1 40.8-40.4 0.2-10.4-30.9-36.1-57.4-37-26.6-0.9-61.9 33.4-61.9 33.4 0 0 11.9-14.8 11.5-16-0.4-1.2-17.4 6-20.4 18.2 0 0 3.1-15.4 1.8-15.6-1.3-0.3-14.4 13.1-11.2 23 0 0-15.2 13.5-16.4 28.2-1.1 14.6 4.5 65.2 16 68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m446.5 405.7c-7.4 3.6-14.9 7.5-23.2 8.7-8.9 1.4-18.2-0.7-26.6-3.8-8.6-3.1-16.5-7.7-23.6-13.4-6.3-5-11.8-11-18.5-15.5-1.7-1.1-3.6 1.3-2.5 2.8 10.2 14.9 28.2 27.1 45.3 32.3 18.1 5.4 34.9 1.1 49.2-10.9 0.1-0.1 0-0.2-0.1-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m348 464.5c0 0-14.2-29.2-27.1-24.5-13 4.7-5.2 44.9 8 52.4 13.1 7.4 20.2-4.7 20.2-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m323.4 451.5c-0.2-0.1-0.3 0.2-0.1 0.4 9.1 5.5 12.9 15.4 15 25.4-2.4-4.1-6-6.7-11.4-4-0.3 0.1-0.1 0.6 0.1 0.6 4.2-0.3 7 0.9 9.2 4.5 1.6 2.6 2.4 5.7 3.4 8.6 0.3 0.9 2 0.7 1.8-0.4q0-0.1-0.1-0.2c2.3-12.5-4.7-31.5-17.9-34.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m330.4 436.6c0 0-0.2-45.3 12-70.6 5.9-12.4 18.9-17.6 33.8-19 0 0-7.9 4.1-17.3 22.1-9.7 18.5-13.5 68.9-13.5 68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m372.3 459.7c0.1 22.9-16.1 41.5-36.2 41.5-20.1 0.1-36.4-18.5-36.5-41.3-0.1-22.9 16.2-41.5 36.3-41.6 20 0 36.4 18.5 36.4 41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m361.7 458.4c0.1 20.6-14.5 37.3-32.6 37.3-18 0.1-32.7-16.6-32.7-37.1-0.1-20.6 14.5-37.3 32.6-37.4 18 0 32.7 16.6 32.7 37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m343.9 458.8c0.1 12.7-8.9 22.9-20 23-11.1 0-20.1-10.2-20.1-22.9-0.1-12.6 8.9-22.9 20-22.9 11.1-0.1 20.1 10.2 20.1 22.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m396.4 526.1l-26.2-7.5-23.1-22.3 3.5-3.6 22.2 21.4 25 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m393.3 522.5c1.5-7.6 22-7.5 19.8 3.9-2.3 11.5-21.4 3.6-19.8-3.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m388.7 575.2l-11.2 35.3-56.3-76.4-21.2 21.6 64.4 91.7 14.3-29.1 17.3 18.8 0.7-44.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m300 555.7c22.4 31.6 41.5 63.4 64.8 94.4l0.8-2.2 14.2-29.3-1.9 0.4 17.5 18.7 1.5 1.6c0.1-15.4-0.1-30.8-0.2-46.3-0.6 14.7-1.2 29.4-1.5 44.1l1.5-0.6-17.1-19-1.3-1.4-0.6 1.8-14.5 29.1 2.2-0.3c-22.7-30.4-41.8-61.3-65.4-91z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "24/7 Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m242.7 461.4c0 49.2-40 89.2-89.2 89.2-49.2 0-89.1-40-89.1-89.2 0-49.2 39.9-89.1 89.1-89.1 49.2 0 89.2 39.9 89.2 89.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m174.9 532.2c-6.8 2.1-13.9 3.2-21.4 3.2-16.6 0-32-5.5-44.4-14.8-17.9-13.5-29.6-35-29.6-59.2 0-27.8 15.4-52.1 38.1-64.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m225.3 443.3c1.4 5.8 2.2 11.9 2.2 18.1 0 26.7-14.2 50.1-35.3 63.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m127.8 392c8-2.9 16.7-4.6 25.7-4.6 26.8 0 50.2 14.3 63.2 35.5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ZZtZDI 00000148658496621575983600000010017603473676605099 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m171.2 517.4c-1.5 1.4-3.3 2.2-5.3 2.7-1.2 0.4-2.5 0.5-3.8 0.8h-4.3c-1.8-0.3-3.6-0.5-5.3-0.9-6.6-1.3-12.6-4.1-18.1-7.8-14.5-9.7-26.3-21.9-35.4-36.7-3-4.9-5.1-10.1-6.1-15.8-0.3-1.5-0.5-3-0.7-4.4v-4.4c0.4-1.6 0.6-3.3 1.1-5q0.6-2.3 2.4-4 0.3 0.2 0.6 0.5 10.3 10.3 20.7 20.7c0.5 0.5 0.5 0.9 0.4 1.5-1 3.7-0.4 7.1 2.2 10q8.8 10 18.9 18.9c2.9 2.5 6.3 3.2 10 2.2 0.5-0.2 0.9-0.2 1.3 0.2q10.6 10.6 21.2 21.2c0 0.1 0.1 0.1 0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m184.7 501.9v1.4c-0.6 0.9-1.2 1.8-2 2.6-2.1 2.2-4.3 4.4-6.5 6.5-0.2 0.3-0.5 0.5-0.7 0.7q-10.6-10.7-21.2-21.3c2.7-2.8 5.5-5.6 8.4-8.3 1.3-1.3 3.2-1.1 4.5 0.2 1.6 1.6 3.2 3.2 4.8 4.7 3.7 3.8 7.4 7.4 11.1 11.2 0.6 0.6 1.1 1.5 1.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m129 451c-2.7 2.6-5.4 5.1-8 7.5-6.8-6.8-13.9-13.9-21.1-21.1 0.5-0.4 1-0.8 1.5-1.3 1.9-2 3.8-3.9 5.8-5.8 0.8-0.8 1.7-1.3 2.5-2h1.5c0.7 0.6 1.6 1 2.3 1.7 5.2 5.1 10.3 10.3 15.4 15.4 2 2 2 3.7 0.1 5.6z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m153.3 467.4c0 1-0.8 1.8-1.9 1.8h-12q0 0 0 0h-0.1c-0.5 0-1-0.2-1.4-0.6-0.7-0.7-0.6-1.9 0.1-2.6l10.1-9.1c1-0.9 1.4-2.1 1.4-3.3 0-1.1-0.3-2.1-1.1-2.9-0.9-1-2.1-1.5-3.3-1.5-1 0-2.1 0.4-2.9 1.2l-1.1 0.9c-0.7 0.7-1.9 0.7-2.6-0.1-0.7-0.8-0.7-2 0.1-2.7l1.1-0.9c1.5-1.5 3.5-2.1 5.4-2.1 2.3 0 4.5 0.9 6.1 2.6 1.4 1.6 2.1 3.6 2.1 5.5 0 2.2-0.9 4.5-2.7 6.1l-6.4 5.8h7.2c1.1 0 1.9 0.8 1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m175.2 462.9c0 1.1-0.9 1.9-1.9 1.9h-0.4v2.6c0 1-0.8 1.8-1.9 1.8-1 0-1.8-0.8-1.8-1.8v-2.6h-10.7c-0.4 0-0.8-0.1-1.2-0.4-0.8-0.7-0.9-1.8-0.3-2.6l12.6-15.7c0 0 0 0 0.1 0q0-0.1 0.1-0.2c0.1 0 0.1 0 0.1-0.1 0.1 0 0.1 0 0.2-0.1 0 0 0.1 0 0.2 0q0-0.1 0.1-0.1c0-0.1 0.1-0.1 0.2-0.1 0 0 0.1 0 0.1 0 0.1 0 0.2 0 0.3 0q0 0 0 0c0.1 0 0.1 0 0.1 0 0.1 0 0.2 0 0.2 0 0.1 0 0.1 0 0.2 0 0 0 0.1 0 0.2 0.1 0 0 0.1 0 0.1 0q0.1 0.1 0.2 0.1c0.1 0.1 0.1 0.1 0.2 0.1 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0q0.1 0.1 0.1 0.2c0.1 0 0.1 0.1 0.1 0.1 0.1 0 0.1 0.1 0.2 0.2 0 0 0 0.1 0 0.1 0.1 0.1 0.1 0.1 0.1 0.2 0 0.1 0 0.1 0 0.2 0.1 0 0.1 0.1 0.1 0.2 0 0 0 0.1 0 0.1q0 0.1 0 0.1v13.8h0.4c1 0 1.9 0.8 1.9 1.8zm-6-10.2l-6.8 8.4h6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m179.6 466.7l8.3-19.8c0.4-1 1.5-1.4 2.5-1 0.9 0.3 1.3 1.5 0.9 2.4l-8.3 19.8c-0.3 0.7-1 1.1-1.8 1.1-0.2 0-0.4 0-0.6-0.1-1-0.4-1.5-1.5-1-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m208.1 448l-8.5 20.1c-0.3 0.7-0.9 1.1-1.7 1.1-0.2 0-0.5 0-0.7-0.1-1-0.4-1.4-1.5-1.1-2.4l7.4-17.5h-8.8c-1 0-1.9-0.8-1.9-1.9 0-1 0.9-1.8 1.9-1.8h11.7q0.1 0 0.3 0c0.2 0 0.5 0.2 0.7 0.3q0.1 0 0.1 0.1 0.1 0 0.2 0.1c0 0.1 0.1 0.1 0.1 0.1q0 0.1 0.1 0.2c0 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2 0 0.2 0.1 0.1 0.1 0.1 0.1 0.2 0 0.2 0 0.5 0 0.7q0 0.2-0.1 0.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gears Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m335.4 275.1c0 49.3-39.9 89.2-89.1 89.2-49.3 0-89.2-39.9-89.2-89.2 0-49.2 39.9-89.1 89.2-89.1 49.2 0 89.1 39.9 89.1 89.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m224.9 204.3c6.7-2 13.9-3.1 21.4-3.1 16.6 0 32 5.5 44.3 14.8 18 13.5 29.6 34.9 29.6 59.1 0 27.9-15.3 52.1-38.1 64.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m174.5 293.2c-1.4-5.8-2.2-11.8-2.2-18.1 0-26.6 14.1-50 35.3-63"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m272 344.5c-8 3-16.7 4.6-25.7 4.6-26.8 0-50.2-14.2-63.2-35.5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m296.6 295.2c-0.8 0.5-1.2 1.3-1.2 2.2q0 0.4 0 0.8 0 0.3 0 0.7c0 0.9 0.4 1.7 1.2 2.2l2.6 1.5-5 8.6-2.6-1.5c-0.8-0.4-1.7-0.4-2.5 0.1q-0.6 0.4-1.3 0.7c-0.8 0.4-1.3 1.2-1.3 2.1v3.1h-9.9v-3.1c0-0.9-0.5-1.7-1.3-2.1q-0.7-0.3-1.3-0.7c-0.7-0.5-1.7-0.5-2.5-0.1l-2.6 1.5-5-8.6 2.7-1.5c0.7-0.5 1.2-1.3 1.1-2.2q0-0.4 0-0.7 0-0.4 0-0.8c0.1-0.9-0.4-1.7-1.1-2.2l-2.7-1.5 5-8.6 2.6 1.5c0.8 0.5 1.7 0.4 2.5-0.1q0.6-0.4 1.3-0.7c0.8-0.4 1.3-1.2 1.3-2.1v-3.1h9.9v3.1c0 0.9 0.5 1.7 1.3 2.1q0.7 0.3 1.3 0.7c0.8 0.5 1.7 0.6 2.5 0.1l2.6-1.5 5 8.6zm-15-5.2c-4.5 0-8.1 3.6-8.1 8.1 0 4.5 3.6 8.2 8.1 8.2 4.5 0 8.1-3.7 8.1-8.2 0-4.5-3.6-8.1-8.1-8.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m260.9 270.5c0 18.1-14.7 32.7-32.8 32.7-18.1 0-32.7-14.6-32.7-32.7 0-18.1 14.6-32.7 32.7-32.7 18.1 0 32.8 14.6 32.8 32.7zm-17.5 0c0-8.4-6.8-15.3-15.3-15.3-8.4 0-15.3 6.9-15.3 15.3 0 8.4 6.9 15.3 15.3 15.3 8.5 0 15.3-6.9 15.3-15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m234.4 239.1h-12.6l0.7-8.9h11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m210.4 243.4l-8.9 8.9-5.8-6.8 7.9-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m196.5 263.3v12.6l-8.9-0.7v-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.7 287.3l8.9 8.9-6.8 5.8-7.9-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m220.7 301.2h12.6l-0.7 8.9h-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m244.6 297l8.9-8.9 5.9 6.8-8 7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m258.6 277v-12.6l8.9 0.7v11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m254.4 253.1l-9-8.9 6.8-5.8 8 7.9z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Person Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m540.7 233.3c0 49.2-40 89.1-89.2 89.1-49.2 0-89.2-39.9-89.2-89.1 0-49.3 40-89.2 89.2-89.2 49.2 0 89.2 39.9 89.2 89.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m380.7 254.7c-2.1-6.8-3.2-14-3.2-21.4 0-16.7 5.5-32 14.8-44.4 13.5-18 35-29.6 59.2-29.6 27.8 0 52.1 15.4 64.7 38.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m469.6 305c-5.8 1.5-11.9 2.3-18.1 2.3-26.7 0-50.1-14.2-63.1-35.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m520.9 207.6c2.9 8 4.6 16.6 4.6 25.7 0 26.7-14.2 50.2-35.5 63.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m432.7 209.7c0 10.3 8.4 18.7 18.8 18.7 10.4 0 18.8-8.4 18.8-18.7 0-10.4-8.4-18.8-18.8-18.8-10.4 0-18.8 8.4-18.8 18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m419.1 261.4v7.8c5.3 3.3 11.3 5.9 17.8 7.4 16.7 4.1 33.5 1 47-7.4v-7.8c0-17.8-14.5-32.4-32.4-32.4-17.9 0-32.4 14.6-32.4 32.4z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m133 932.5c235.1-1.2 498.9-1.2 734 0-235.1 1.2-498.9 1.2-734 0z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m501.6 925.6h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m526.8 924.8h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m552 923.9h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m577.2 923.1h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m602.4 922.2h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m627.6 921.4h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m652.8 920.6h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m678 919.7h-19.4v-12.7h19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m703.2 918.9h-19.4v-12.7h19.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m708 932.9h-230.6v-15.5l230.6-6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m842.3 870.7h-319.6l50.9-237.9h319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m854.2 870.7h-319.6l50.8-237.9h319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m747.4 738c-1.7 10.9-12 19.8-22.9 19.8-10.9 0-18.4-8.9-16.6-19.8 1.7-10.9 11.9-19.8 22.9-19.8 10.9 0 18.3 8.9 16.6 19.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m763.8 932.9h-157.2v-12.2l157.2-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m806.5 932.9h-84.4l-50.8-133.4h84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m820.4 932.9h-84.4l-50.8-133.4h84.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m539.9 932.9c0 0-136.3 0-149 0-12.7 0 5.7-36.2 52.1-50.1 46.4-13.9 111.5 36.5 96.9 50.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m481.4 932.9c-0.4-4.2 0.2-8.4 1.3-12.4 1-4.1 2.7-8 4.9-11.7 2.1-3.6 4.9-6.9 8.2-9.6 3.2-2.8 7.1-4.7 11.1-5.9-3.2 2.8-6.2 5.2-8.8 8.3-2.5 3-4.9 6.1-6.9 9.5-4 6.7-7 14-9.8 21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m499.1 898.4c4.6 1 9 2.6 13.2 4.6 4.3 1.9 8.3 4.3 12.2 7 3.9 2.7 7.5 5.9 10.4 9.7 2.9 3.7 5.3 8.4 5 13.2-1.5-4.5-4.4-7.9-7.5-11-3.2-3.1-6.7-5.9-10.4-8.5-7.3-5.2-15.1-9.8-22.9-15z"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m722.2 393.5h-213.3v81.1l-34.9 29.6h34.9v12.4h213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m721.4 515.9c-13.4 0.6-206.2-1.7-211.5 0.5v-12.2-1h-1-32.4l33-28 0.3-0.2v-0.4l-0.2-80.4c53.3-0.1 159.6-0.4 212.6-0.7-0.3 30.4-0.8 91.5-0.8 122.4zm-212.5-121.7c0 0 0.7-0.7 0.7-0.7v0.7q-0.4 0-0.7 0zm-34.3 110.7l-0.6-1.7h2.5zm35.3 11.7q-0.2-0.1 0-0.2zm212.3-0.7q0 0 0 0 0 0 0 0zm-0.7 0.7q0-0.3 0-0.6 0.6 0 0.7-0.1c-0.1 0.1-0.7 0.7-0.7 0.7zm-212.5-123.7h-0.7v0.6l-0.2 80.7-34.7 29.3-2 1.7h2.6 34v11.4c0 0 0 1 0 1 1.9 0 213-0.3 215-0.2 0 0 0-0.8 0-0.8-0.1-30.7-0.5-92.4-0.8-123.1-53.1-0.3-160.1-0.5-213.2-0.6zm-1 111.3l1 1h-1zm0.4-30.2l-0.3 0.6v-0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m686.1 462.7h-156v-2.7h156z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m660.5 477h-130.4v-2.6h130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m668 434h-137.9v-2.7h137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m700.5 419.6h-170.4v-2.6h170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m670.8 491.4h-140.7v-2.7h140.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.47d93e684d7baf902bb6d0813f7f59ea.svg";
export { ForwardRef as ReactComponent };